import {Matrix4} from 'three'

export default {
  uniforms: {
    dataTexture: { type: 't', value: null},
    cornerMaskTexture: { type: 't', value: null },
    neurons: { value: 1.0 },
    normalize: { value: 1.0 },
  },
  
    vertexShader: [
			'uniform float viewWidth, viewHeight, squareWidth, margin, channels;',

			'varying vec2 vUV;',

			'void main(void) {',
      '	gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);',
			'	vUV = uv;',
			'}'
    ].join('\n'),
  
    fragmentShader: [
      'uniform sampler2D dataTexture;',
			'uniform sampler2D cornerMaskTexture;',
      'uniform float neurons;',
      'uniform float normalize;',
			
			'varying vec2 vUV;',
			
			'const vec3 defaultCol = vec3(0.5, 0.5, 0.5);',
			
			'vec3 redBlue(float brightness);',
			
			'void main(void) {',
      '	float activation = texture2D(dataTexture, vec2(vUV.x, 1.0-vUV.y)).r * normalize;',
      '	float cornerMask = texture2D(cornerMaskTexture, vec2(vUV.x*neurons, vUV.y)).r;',
			'vec3 col = redBlue(activation);',
			'if(activation == 1000000.0) {',
      '	col = vec3(1.0);',
			'} else {',
      '		col = redBlue(activation);',
      '	}',
      '	gl_FragColor = vec4(col, cornerMask);',
      '}',
			
			'vec3 redBlue(float brightness) {',
      '	float r,g,b;',
      '	if(brightness > 0.0){',
      '		r = brightness;',
      '	} else {',
      '		b = -brightness;',
      '	}',
      '	return vec3(r,g,b);',
      '}'
    ].join('\n')
  }